import { createContext } from 'react';

export const NavContext = createContext<{
  collapsed: boolean;
  setCollapsed: (state: boolean) => void;
  navDisabled: boolean;
  setNavDisabled: (state: boolean) => void;
  submenu: boolean;
  setSubmenu: (state: boolean) => void;
  leftSidebar: boolean;
  setLeftSidebar: (state: boolean) => void;
  headerDisabled: boolean;
  setHeaderDisabled: (state: boolean) => void;
  subPage: boolean;
  setSubPage: (state: boolean) => void;
  leftSidebarToggle: boolean;
  setLeftSidebarToggle: (state: boolean) => void;
}>({
  collapsed: false,
  setCollapsed: () => {},
  navDisabled: false,
  setNavDisabled: () => {},
  submenu: false,
  setSubmenu: () => {},
  leftSidebar: false,
  setLeftSidebar: () => {},
  headerDisabled: false,
  setHeaderDisabled: () => {},
  subPage: false,
  setSubPage: () => {},
  leftSidebarToggle: false,
  setLeftSidebarToggle: () => {},
});
